export default "__VITE_PUBLIC_ASSET__6872763c__"